// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"d988e55c","367":"23d7cd19","375":"6707ea47","457":"1358da9c","488":"c07103c3","529":"9ee432b3","654":"a36c8c64","775":"9342a0e0","947":"d670d346"}[chunkId] + ".chunk.js";
};